export const token = process.env.SANITY_API_READ_TOKEN;
